import React, { memo } from 'react';
import { getMessage } from '@tcc/i18n';
import { Icon, Link } from '@tcc/crate';

import { FIELD_VIEW_URL } from 'constants/urls';
import { useAppSelector } from 'app/hooks';
import ZoneGenerationNoData from './ZoneGenerationNoData';
import { getCropsFromYieldLayers, getSelectedMapLayer } from './selectors';
import ZoneGenerationYieldCropTypeSelection from './ZoneGenerationYieldCropTypeSelection';
import ZoneGenerationYieldLayerSelection from './ZoneGenerationYieldLayerSelection';

const ZoneGenerationYieldContent = () => {
  const crops = useAppSelector(getCropsFromYieldLayers);
  const { selectedMapType } = useAppSelector(getSelectedMapLayer);

  if (!crops.length) {
    return (
      <ZoneGenerationNoData
        message={getMessage('text__generate-zones-layers-no-yield-data')}
        action={
          <Link href={FIELD_VIEW_URL.DATA_INBOX}>
            <Icon glyph={Icon.set.ADD} />
            {getMessage('help-text__more-data__next-steps--1--link')}
          </Link>
        }
      />
    );
  }

  return (
    <>
      <ZoneGenerationYieldCropTypeSelection crops={crops} selectedMapType={selectedMapType} />
      <ZoneGenerationYieldLayerSelection selectedMapType={selectedMapType} />
    </>
  );
};

export default memo(ZoneGenerationYieldContent);
